import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Box, Typography } from "@mui/material";
export const VarianceBadge = React.memo(({ value, bold }) => {
    const isPos = value >= 0;
    return (_jsxs(Box, { sx: {
            backgroundColor: isPos ? "#ecfdf3" : "#fef3f2",
            borderRadius: "16px",
            px: 1,
            py: 0.5,
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
        }, children: [_jsxs(Typography, { className: "all-Font-Sizes", sx: {
                    fontFamily: "Inter",
                    fontWeight: bold ? 700 : 500,
                    color: isPos ? "#027a48" : "#b42318"
                }, children: [Math.abs(value).toLocaleString("en-US", { maximumFractionDigits: 0 }), "%"] }), _jsx("img", { src: isPos ? "/assets/trend-up.svg" : "/assets/trending-down.svg", alt: "" })] }));
});
